import React, { useState, useEffect, useRef } from 'react';
import { Flex } from 'ui/acro'
import {SubStyleChip} from '../styles'

const SubCategoryChipList = ({ subcategories }) => {
    const containerRef = useRef(null);
    const cardRefs = useRef([]);
    const [visibleCards, setVisibleCards] = useState(subcategories);
    const [hiddenCount, setHiddenCount] = useState(0);

    useEffect(() => {
        const calculateVisibleCards = () => {
          if (!containerRef.current || !cardRefs.current.length) return;
    
          const containerWidth = containerRef.current.offsetWidth;
          const containerHeight = containerRef.current.offsetHeight; //
          let usedWidth = 0;
          let usedHeight = 0; //
          let fitCount = 0;
          let rowCount = 1; //
  
          for (let i = 0; i < subcategories.length; i++) {
            const card = cardRefs.current[i];
            if (!card) continue;
    
            const cardWidth = card.offsetWidth;
            const cardHeight = card.offsetHeight;
    
            // Move to second row if overflowing width
            if (usedWidth + cardWidth > containerWidth) {
              rowCount++;
              usedWidth = 0;
              usedHeight += cardHeight;
            }
    
            // If exceeding second row, stop adding cards
            if (rowCount > 2 || usedHeight + cardHeight > containerHeight) break;
    
            usedWidth = usedWidth + cardWidth + 4;
            fitCount++;
          }
    
          if (fitCount < subcategories.length) {
            setVisibleCards(subcategories.slice(0, fitCount - 1)); // Leave space for `+X`
            // setVisibleCards(subcategories.slice(0, fitCount));
            setHiddenCount(subcategories.length - (fitCount-1));
          } else {
            setVisibleCards(subcategories);
            setHiddenCount(0);
          }
        };
    
        calculateVisibleCards();
        window.addEventListener("resize", calculateVisibleCards);
    
        return () => window.removeEventListener("resize", calculateVisibleCards);
        
    }, [])
    
    return (
        <Flex
            ref={containerRef}
            mt='12px'
            gap='4px'
            flexWrap={['wrap', 'nowrap', 'nowrap', 'nowrap']}
            alignItems= 'center'
            >
              {visibleCards.map((subStyle, index) => {
                return <SubStyleChip ref={(el) => (cardRefs.current[index] = el)}>{subStyle.title}</SubStyleChip>
              })}
            {hiddenCount > 0 && (
              <div style={{fontSize:'12px',color:'#000'}}>
                +{hiddenCount}
              </div>
            )}
            </Flex>
    )
}
export default SubCategoryChipList;